import {
  DrawerTooltipContainer,
  DrawerTooltipContainerRef,
} from 'src/v2/commonComponents/DrawerTooltipContainer';
import { useRef } from 'react';
import { NewEditorButton } from 'src/v2/components/NewContentButton/components/NewEditorButton';
import { ArtifactType } from 'src/types';
import { AddDocumentToggle } from '../AddDocumentToggle';
import styles from './AddDocumentControl.module.scss';
import { useGetUser } from 'src/hooks';

const tooltipAnchorId = 'add-document-button-tooltip-anchor';

export const AddDocumentControl = () => {
  const drawerRef = useRef<DrawerTooltipContainerRef>(null);

  const { isOpenTier } = useGetUser();

  const handleClick = () => {
    drawerRef.current?.onVisibilityToggle();
  };

  return (
    <DrawerTooltipContainer
      ref={drawerRef}
      disabledToggle={isOpenTier}
      id={tooltipAnchorId}
      place="bottom"
      offset={8}
      ToggleButton={AddDocumentToggle}
      onlyTooltip
    >
      <div className={styles.container}>
        <NewEditorButton
          withTitle
          buttonType={ArtifactType.TEXT}
          onClick={handleClick}
        />
        <NewEditorButton
          withTitle
          buttonType={ArtifactType.CODE}
          onClick={handleClick}
        />
      </div>
    </DrawerTooltipContainer>
  );
};
